import React, { useEffect, useRef, useState } from "react"

import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import PropTypes from "prop-types"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"

import reducer from "./reducer"
import saga from "./saga"
import {
  makeSelectTeamsDrillDown,
  makeSelectDimensions,
  makeSelectIsLoadingTeams,
  makeSelectMetric,
  makeSelectTeams,
} from "./selectors"
import { getTeamsWatcher } from "./actions"

import "./index.less"
import ResultDrillDown from "../../../../../containers/Report/Home/Components/ResultDrillDown"
import { isLeader, isLeaderActive } from "../../../../../utils/storage"

import { getLanguage, loadTexts, sanitize } from "../../../../../utils/i18n"

/*
import { Spin } from "antd"
*/

function usePreviousMeasureID(value) {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

function usePreviousDivisionID(value) {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

export function WidgetResultByTeam(props) {
  const intlWidgetResultByTeam = loadTexts("reports_general_view")
    .reportAmbassador.leadershipMeasurement.widgetResultByTeam
  const [measureID] = useState(props.idMeasure)
  const [divisionID] = useState(props.idDivisionSelected)
  const prevMeasureID = usePreviousMeasureID(measureID)
  const prevDivisionID = usePreviousDivisionID(divisionID)

  useEffect(() => {
    if (prevMeasureID !== measureID) {
      initGetData()
    } else {
      if (prevDivisionID !== divisionID) {
        initGetData()
      }
    }
  }, [props.idMeasure, props.idDivisionSelected])

  const initGetData = async () => {
    const { idMeasure, getTeams, measureGeneral, selectedSegment } = props
    const params = {
      id_measure: idMeasure,
      id_survey_type: measureGeneral.id_survey_type,
      id_segment: selectedSegment,
    }
    getTeams(params)
  }

  const changeDivisionTeams = (value) => {
    const { measureGeneral, idMeasure, getTeams, selectedSegment } = props
    const params = {
      dimension: value,
      id_measure: idMeasure,
      id_survey_type: measureGeneral.id_survey_type,
      id_segment: selectedSegment,
    }
    getTeams(params)
  }
  const link = () => {
    const { measureGeneral, selectedSegment } = props
    let queryParams = ""
    if (measureGeneral.segments.length > 1 && selectedSegment) {
      queryParams = `?id_segment=${selectedSegment}`
    }
    if (measureGeneral.segments.length === 1) {
      queryParams = `?id_segment=${measureGeneral.segments[0].id_segment}`
    }
    return `/reports/measure/${props.idMeasure}/teams${queryParams}`
  }

  return (
    <ResultDrillDown
      textLeyend="Organización"
      isLoading={props.isLoadingTeams}
      metric={props.metric}
      data={props.teamsDrillDown}
      textEmpty={
        <p>
          {getLanguage() == 'es'
            ? sanitize(intlWidgetResultByTeam.empty.section1 + " " +
              (isLeaderActive()
              ? intlWidgetResultByTeam.empty.leader
              : intlWidgetResultByTeam.empty.teams))
            : sanitize(intlWidgetResultByTeam.empty.section1 + "<strong>" + (isLeaderActive()
              ? intlWidgetResultByTeam.empty.leader
              : intlWidgetResultByTeam.empty.teams + "</strong>" + intlWidgetResultByTeam.empty.section2)) }
        </p>
      }
      forceEmpty={props.teams.length <= 1 && isLeaderActive()}
      title={
        isLeaderActive()
          ? intlWidgetResultByTeam.titleByLeader
          : intlWidgetResultByTeam.titleByTeam
      }
      filters={{
        show: true,
        filters: props.dimensions,
        id: "id_dimension",
        name: "dimension_name",
        drilldown: ["id", "id_parent"],
        placeHolder: intlWidgetResultByTeam.selectDimensionPlaceHolder,
        onChange: changeDivisionTeams,
      }}
      subLink={{
        title: isLeaderActive()
          ? intlWidgetResultByTeam.linkLeaders
          : intlWidgetResultByTeam.linkTeams,
        link: link(),
      }}
      isLeadership
      measure_general={props.measureGeneral}
    />
  )
}

WidgetResultByTeam.propTypes = {
  typeMeasurement: PropTypes.string,
  idMeasure: PropTypes.number,
  measureTotal: PropTypes.object,
  measureGeneral: PropTypes.object,
  idDivisionSelected: PropTypes.number,
  idDivisionParent: PropTypes.number,
  isLoadingTeams: PropTypes.bool,
  teamsDrillDown: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  dimensions: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  teams: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  metric: PropTypes.object,
  getTeams: PropTypes.func,
}

const mapStateToProps = createStructuredSelector({
  isLoadingTeams: makeSelectIsLoadingTeams(),
  teamsDrillDown: makeSelectTeamsDrillDown(),
  dimensions: makeSelectDimensions(),
  metric: makeSelectMetric(),
  teams: makeSelectTeams(),
})

function mapDispatchToProps(dispatch) {
  return {
    getTeams: (params) => dispatch(getTeamsWatcher(params)),
  }
}
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withReducer = injectReducer({ key: "widgetResultByTeam", reducer })
const withSaga = injectSaga({ key: "widgetResultByTeam", saga })

export default compose(withReducer, withSaga, withConnect)(WidgetResultByTeam)
